import styled from 'styled-components';
import palette from '@mlc/mlc-palette';
import { Label, Paragraph } from '@mlc/web-ui-toolkit';
import { Color, ScreenSize } from '../../../../enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TrackableAnchor from '../../../common/Anchor/TrackableAnchor';
import Image from '../../Common/Image/Image';

export const Card = styled.div`
	border: 1px solid ${Color.border};
	box-sizing: border-box;
	cursor: pointer;
	height: 100%;
	padding: 20px 30px;
	position: relative;
	text-align: center;
	width: 100%;

	&:focus,
	&:hover {
		background-color: ${palette.mlcKoala};
	}

	&:focus h4,
	&:hover h4 {
		color: ${palette.mlcTextLink};
		text-decoration: underline;
	}
`;

export const Anchor = styled(TrackableAnchor)`
	color: ${palette.mlcText};
	text-decoration: none;
`;

export const Title = styled(Label)`
	color: ${palette.mlcText};
	line-height: 36px;
	margin: 0;
	padding: 0.5rem;
	padding-bottom: 0;
	padding-top: 3px;

	@media (max-width: ${ScreenSize.medium}) {
		margin: 0 -30px;
	}
`;

export const Text = styled(Paragraph)`
	line-height: 24px;
	margin: 0;
`;

export const NewTabIcon = styled(FontAwesomeIcon)`
	margin-left: 5px;
`;

export const Img = styled(Image)`
	display: block;
	margin: 0 auto;
	width: fit-content;
`;
